const enUK = import(/* webpackChunkName:"en-UK" */ '../../locales/en-UK.json');
const nlBE = import(/* webpackChunkName:"nl-BE" */ '../../locales/nl-BE.json');

import Vue from 'vue'
import { mapGetters } from 'vuex'

Vue.mixin({
    computed: {
      ...mapGetters('localization', ['L'])
    }    
})

export default {
    namespaced: true,
    state: {
        language: 'nl-BE',
        area: null,
        resources: {},
    },
    getters: {
        language(state) {
            return state.language;
        },
        L(state, getters, rootState) {
            return key => {
                let area = rootState.area;
                
                if(area && state.resources[area] && state.resources[area][key]) {
                    return state.resources[area][key];
                }

                return state.resources[key];
            }
        }
    },
    mutations: {
        'SET_LANGUAGE' (state, value) {
            state.language = value;
        },
        'SET_RESOURCES'(state, value) {
            state.resources = value;
        }
    },
    actions: {
        async loadLocalization({ getters, commit }) {
            switch(getters.language) {
                case 'nl-BE': commit('SET_RESOURCES', await nlBE); break;
                case 'en-UK': commit('SET_RESOURCES', await enUK); break;
            }
        },
        changeLanguage({ dispatch, commit }, value) {
            commit('SET_LANGUAGE', value);
            dispatch('loadLocalization');
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/localization.js